// extracted by mini-css-extract-plugin
export default {"title":"RecordValuesTable_title__PdQCx"};